<div class="order-posted-picklist-preview" [ngClass]="{ compact }">
  <div
    class="flex justify-space-between my-3 w-100"
    [ngClass]="{
      'gap-10 align-items-start': compact,
      'align-items-center': !compact,
    }"
  >
    <div class="block">
      <h3 *ngIf="!compact" class="pt-4">Picklist Preview</h3>
      <div class="text-nowrap">Sales Order Number(s):</div>
      <div *ngIf="!loading || orderNumbers.length > 0" class="mb-3 mt-1">
        <ng-container
          *ngFor="
            let orderNumber of orderNumbers;
            let i = index;
            trackBy: trackByValue
          "
        >
          <a
            *ngIf="i < orderNumberMaxDisplay"
            target="_blank"
            [routerLink]="['/shipping/posted-orders']"
            [queryParams]="{ orderNumber: orderNumber }"
          >
            {{ orderNumber }}
          </a>
        </ng-container>

        <span *ngIf="orderNumbers.length > 4" class="text-underline cursor-pointer">
          <span
            *ngIf="orderNumberMaxDisplay === 4; else showLess"
            (click)="orderNumberMaxDisplay = orderNumbers.length"
          >
            Show more({{ orderNumbers.length - 4 }})
          </span>
          <ng-template #showLess
            ><span (click)="orderNumberMaxDisplay = 4">
              Show less
            </span></ng-template
          >
        </span>
      </div>
    </div>
    <button
      *ngIf="!compact"
      type="button"
      class="lum-button lum-button--secondary picklist-packing__close-btn"
      mat-button
      (click)="closeEvent.emit(false)"
    >
      <lum-ui-icon
        class="mr-2-5"
        icon="close-circle"
        color="#5563D6"
        width="23"
        height="23"
      ></lum-ui-icon>
      Close
    </button>

    <ng-container *ngIf="compact">
      <button
        class="lum-button lum-button--secondary shrink-0"
        type="button"
        mat-button
        [matMenuTriggerFor]="menu"
      >
        Actions
        <i class="fas fa-ellipsis-v ml-2"></i>
      </button>
      <mat-menu class="lum-mat-menu" #menu="matMenu">
        <button
          mat-menu-item
          (click)="quickFulfillmentFlowEvent.emit('create_picklist')"
        >
          Create Picklist
        </button>
        <button
          mat-menu-item
          (click)="quickFulfillmentFlowEvent.emit('bulk_update_tags')"
        >
          Update Tags
        </button>
        <button
          *ngIf="config.canUpdateCheckedOrderStatus"
          mat-menu-item
          (click)="quickFulfillmentFlowEvent.emit('bulk_update_order_status')"
        >
          Update Order Status
        </button>
        <button
          mat-menu-item
          (click)="quickFulfillmentFlowEvent.emit('export_packing_slip')"
        >
          Export Packing Slip(s)
        </button>
        <button
          *ngIf="appIntegrationAccountId !== null"
          mat-menu-item
          (click)="printShippingLabels()"
        >
          Print Shipping Labels
        </button>
      </mat-menu>
    </ng-container>
  </div>
  <ng-container *ngIf="orderNumbers.length > 0">
    <ng-container *ngIf="!compact">
      <div class="flex justify-content-end mb-3 gap-2">
        <button
          mat-button
          class="lum-button lum-button--secondary"
          (click)="quickFulfillmentFlowEvent.emit('create_picklist')"
        >
          <i class="fas fa-list mr-2"></i> Create picklist
        </button>
        <button
          class="lum-button lum-button--secondary"
          type="button"
          mat-button
          [matMenuTriggerFor]="menu"
        >
          <i class="fas fa-edit mr-2"></i>
          Bulk Update
        </button>
        <mat-menu class="lum-mat-menu" #menu="matMenu">
          <button
            mat-menu-item
            (click)="quickFulfillmentFlowEvent.emit('bulk_update_tags')"
          >
            Update Tags
          </button>
          <button
            *ngIf="config.canUpdateCheckedOrderStatus"
            mat-menu-item
            (click)="quickFulfillmentFlowEvent.emit('bulk_update_order_status')"
          >
            Update Order Status
          </button>
        </mat-menu>
        <button
          mat-button
          class="lum-button lum-button--secondary"
          (click)="quickFulfillmentFlowEvent.emit('export_packing_slip')"
        >
          <i class="fas fa-file-pdf mr-2"></i> Export Packing Slip(s)
        </button>
        <button
          *ngIf="appIntegrationAccountId !== null"
          type="button"
          class="lum-button lum-button--primary"
          mat-button
          (click)="printShippingLabels()"
        >
          <lum-ui-icon
            class="pr-1 pb-1"
            icon="export-pdf"
            color="#ffffff"
          ></lum-ui-icon>
          Print Shipping Labels
        </button>
      </div>
    </ng-container>
  </ng-container>
  <div class="lum-table-wrapper">
    <table
      *ngIf="!loadingPicklistItems; else loader"
      class="lum-table lum-table--classic striped"
      matSort
      (matSortChange)="sortData($event)"
    >
      <thead>
        <tr>
          <th [mat-sort-header]="picklistPreviewSortId.INTERNAL_SKU">
            <span [ngClass]="{ 'w-30': compact }">Ordered SKU</span>
          </th>
          <th [mat-sort-header]="picklistPreviewSortId.PRODUCT_NAME">
            <span [ngClass]="{ 'w-30': compact }">Name</span>
          </th>
          <th [mat-sort-header]="picklistPreviewSortId.LOCATION_NAME">
            <span [ngClass]="{ 'w-65': compact }">Location</span>
          </th>
          <th [mat-sort-header]="picklistPreviewSortId.LOT_NUMBER">
            <span [ngClass]="{ 'w-45': compact }">Lot</span>
          </th>
          <th [mat-sort-header]="picklistPreviewSortId.QUANTITY">
            <span [ngClass]="{ 'w-35': compact }">Ordered Quantity</span>
          </th>
          <th [mat-sort-header]="picklistPreviewSortId.AVAILABLE_QUANTITY">
            <span [ngClass]="{ 'w-35': compact }">Available Quantity</span>
          </th>
          <th width="60px">&nbsp;</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngIf="pickingItems.length > 0">
          <tr
            *ngFor="let pickingItem of pickingItems"
            [class]="{ 'text-danger': !pickingItem.fulfilled }"
          >
            <td>
              <div class="flex align-items-center gap-4">
                <img
                  [lumRfqThumbnailUrl]="pickingItem"
                  [src]="pickingItem?.photo"
                  alt=""
                  class="lum-img lum-thumbnail sku-img-preview"
                />

                {{ pickingItem?.internalSku }}
              </div>
            </td>
            <td>{{ pickingItem?.productName }}</td>
            <td>{{ pickingItem?.locationName }}</td>
            <td>{{ pickingItem?.lotNumber }}</td>
            <td class="text-center">
              {{ pickingItem?.quantity | decimalPlaces }}
            </td>
            <td class="text-center">
              {{ pickingItem?.availableQuantity | decimalPlaces }}
            </td>
            <td class="p-0 text-dark">
              <div class="pr-4">
                <button class="" mat-icon-button [matMenuTriggerFor]="menu">
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #menu="matMenu">
                  <button
                    mat-menu-item
                    (click)="adjustmentEntryEvent.emit(pickingItem?.rfqId)"
                  >
                    Create Adjustment Entry
                  </button>
                </mat-menu>
              </div>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
  <div
    *ngIf="!loadingPicklistItems && pickingItems.length === 0"
    class="flex justify-content-center py-4 text-danger"
  >
    No sales order has been selected.
  </div>

  <ng-template #loader>
    <mat-option>
      <div class="flex gap-4">
        <mat-progress-spinner
          class="progress-spinner mt-3"
          diameter="24"
          mode="indeterminate"
        ></mat-progress-spinner>
        <small>Loading...</small>
      </div>
    </mat-option>
  </ng-template>
</div>
